// For web platform, define $RefreshReg$ and $RefreshSig$ before imports
// This prevents "ReferenceError: $RefreshReg$ is not defined" errors
if (typeof window !== 'undefined') {
  (window as any).$RefreshReg$ = function() {};
  (window as any).$RefreshSig$ = function() {
    return function(type: any) {
      return type;
    };
  };
}

import { registerRootComponent } from 'expo';
import { Platform } from 'react-native';
import App from './App';
import { disableNativeRtl } from './src/utils/nativeLayoutDirection';

disableNativeRtl();

// Must be registered at root level BEFORE registerRootComponent so Firebase can
// handle background messages when React has not yet mounted (app in background).
if (Platform.OS !== 'web') {
  try {
    const messaging = require('@react-native-firebase/messaging').default;
    messaging().setBackgroundMessageHandler(async (remoteMessage: any) => {
      // System automatically displays the notification — nothing to do here.
    });
  } catch (e) {
    // Firebase not available in this environment (e.g. Expo Go)
  }
}

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
